<template>
    <rkm-form-incremental-textarea
        :items="data.form.atendimentoEnfermagem.historicos"
        :validations="validations.historico"
        v-model="data.model.historico"
        :readonly="readonly"
        label="Histórico de enfermagem"
    >
        <template v-slot:row="{ item }">
            <rkm-row>
                <rkm-col cols="4">
                    <div>Setor: {{ item.centroCusto.setor.nome }}</div>
                    <div>{{ item.lotacao.profissional.nome }}</div>
                    <div>Class. Risco: {{ item.classificacaoRisco.nome }}</div>
                    <div>{{ item.dataHora }}</div>
                </rkm-col>

                <rkm-col>
                    {{ item.descricao }}
                </rkm-col>
            </rkm-row>
        </template>
    </rkm-form-incremental-textarea>
</template>

<script>
// Components.
import RkmFormIncrementalTextarea from '@/components/pronto-atendimento/components/base/FormIncrementalTextarea'

export default {
    components: { RkmFormIncrementalTextarea },
    computed: {
        validations() {
            return {
                historico: { max: 3000 },
            }
        },
    },
    props: {
        data: { type: Object, required: true },
        readonly: { type: Boolean, default: false },
    },
}
</script>